import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppState } from 'src/app/root-store/state';
import { Store, select } from '@ngrx/store';
import { toggleExpandLocationFilter, toggleExpandCategoryFilter, toggleExpandSalaryFilter, toggleExpandExperienceFilter, toggleExpandAnnouncementTypeFilter, toggleExpandPublishDateFilter, updateFilter, announcementSearch, resetFilter, updateKeywordFilter, toggleExpandFilter, updateSubmittedFilter, updateCategoryilter, updatePublishDateFilter, updateExperienceFilter, updateSalaryFilter, updateOnlySelectedSalaryFilter, updateLocalityFilter, updateEmploymentFormFilter, updateSpecializationFilter, updateIndustryFilter, updateSeniorityLevelFilter, updateEmploymentFormTypeFilter, updateTransportTypeFilter, updateWorkScheduleFilter, updateLanguageFilter, updateDrivingLicenceFilter, updateEducationLevelFilter, updateSkillsFilter, loadSkillSuggestions, loadSelectedSkills } from 'src/app/root-store/announcement-store/search-page/actions';
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';
import { selectLocationExpanded, selectLocationFilterActive, selectSalaryExpanded, selectSalaryFilterActive, selectExperienceExpanded, selectExperienceFilterActive, selectAnnouncementTypeExpanded, selectAnnouncementTypeFilterActive, selectPublishDateExpanded, selectPublishDateFilterActive, selectFilter, selectFilterExpanded, selectLocationCount, selectExperienceCount, selectCategoryIds, selectExperienceFilter, selectLocalityIds, selectSpecializationCodes, selectIndustryCodes, selectLanguageIds, selectHardSkills, selectSoftSkills, selectSkillSuggestions } from 'src/app/root-store/announcement-store/search-page/selectors';
import { SearchPageActions } from 'src/app/root-store/announcement-store/search-page';
import { ActivatedRoute, NavigationSkipped, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { AnnouncementFilter } from 'src/app/shared/models/announcement-filter';
import { selectSalaryOptions, selectPublishDateOptions, selectSearchResultsStateInfo, selectCategoriesTree, selectDefaultPublishDateOption, selectSeniorityLevelOptions, selectTransportTypeOptions, selectEmploymentFormOptions, selectWorkScheduleOptions, selectDrivingLicenceOptions, selectEducationLevelOptions, selectWorldLanguages} from 'src/app/root-store/selectors';
import { AnnouncementService } from 'src/app/shared/services/announcement.service';
import { JobseekerSkillViewModel, OptionItem, SkillAutoCompleteResult, SkillBaseTypeEnum, TreeSelectModel, WorkExperienceFilterModel } from '@hrra/common-models';
import { LogginService, Range, SsrService, UI_LIMITS } from '@hrra/core';
import { SeniorityLevelItem } from 'src/app/shared/models/seniority-level.model';
import { TransportTypeItem } from 'src/app/shared/models/transport-type-model';
import { EmploymentFormItem } from 'src/app/shared/models/employment-form-type-model';
import { Location } from '@angular/common';
import pino from 'pino';
import { WorkScheduleItem } from 'src/app/shared/models/work-shchedule.model';
import { DrivingLicenceItem } from 'src/app/shared/models/driving-licence.model';
import { EducationLevelItem } from 'src/app/shared/models/education-level.model';
import { WorldLanguageItem } from 'src/app/shared/models/world-language.model.ts';

@Component({
    selector: 'app-ann-search-filter',
    templateUrl: './ann-search-filter.component.html',
    styleUrls: ['./ann-search-filter.component.scss'],
    standalone: false
})
export class AnnSearchFilterComponent implements OnInit, OnDestroy {

  @ViewChild('tree')
  public tree!: any;

  @ViewChild('locationTreeSelect')
  public locationTreeSelect!: any;

  @ViewChild('seniorityLevelMultiSelect')
  public seniorityLevelMultiSelect!: any;

  @ViewChild('transportTypeMultiSelect')
  public transportTypeMultiSelect!: any;

  @ViewChild('workScheduleMultiSelect')
  public workScheduleMultiSelect!: any;

  @ViewChild('specializationTreeSelect')
  public specializationTreeSelect!: any;

  @ViewChild('industryTreeSelect')
  public industryTreeSelect!: any;

  @ViewChild('publishDateDropdown')
  publishDateDropdown!: any;

  @ViewChild('announcementTypeDropdown')
  announcementTypeDropdown!: any;

  @ViewChild('salaryDropdown')
  salaryDropdown!: any

  @ViewChild('drivingLicenceMultiSelect')
  public drivingLicenceMultiSelect!: any;

  @ViewChild('languageMultiselect')
  public languageMultiselect!: any;

  @ViewChild('educationLevelMultiSelect')
  public educationLevelMultiSelect!: any;

  public forceRefresh$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  public localityTree$: Observable<TreeSelectModel<number>[]>

  //locations
  public isLocationFilterExpanded$: Observable<boolean>;
  public isLocationFilterActive$: Observable<boolean>;

  public localityIds$: Observable<number[]>;
  public specializationCodes$: Observable<string[]>;
  public industryCodes$: Observable<string[]>;

  //categories 
  public categoryTree$: Observable<TreeSelectModel<number>[]>;
  public categoryIds$: Observable<number[]>;

  private sub: Subscription
  private routeParamsSub: Subscription;
  //Todo: remove
  // public isCategoryFilterExpanded$: Observable<boolean>;
  // public isCategoryFilterActive$: Observable<boolean>;


  //salary
  public isSalaryFilterExpanded$: Observable<boolean>;
  public isSalaryFilterActive$: Observable<boolean>;

  //experience
  public isExperienceFilterExpanded$: Observable<boolean>;
  public isExperienceFilterActive$: Observable<boolean>;

  public experienceFilter$: Observable<WorkExperienceFilterModel>;

  //announcement type
  public isAnnouncementTypeFilterExpanded$: Observable<boolean>;
  public isAnnouncementTypeFilterActive$: Observable<boolean>;

  //publish date
  public isPublishDateFilterExpanded$: Observable<boolean>;
  public isPublishDateFilterActive$: Observable<boolean>;

  //filter
  public filter$: Observable<AnnouncementFilter>;
  
  public isFilterExpanded$: Observable<boolean>;

  public salaryOptions$: Observable<OptionItem<Range<number>>[]>;
  public publishDateOptions$: Observable<OptionItem<Range<number>>[]>;
  public publishDefaultDateOption$: Observable<OptionItem<Range<number>>>;

  public seniorityLevelOptions$: Observable<SeniorityLevelItem[]>;

  public workScheduleOptions$: Observable<WorkScheduleItem[]>;

  public transportTypeOptions$: Observable<TransportTypeItem[]>

  public drivingLicenceOptions$: Observable<DrivingLicenceItem[]>;

  public educationLevelOptions$: Observable<EducationLevelItem[]>;

  public languageOptions$: Observable<WorldLanguageItem[]>;

  public languageIds$: Observable<number[]>;

  //skills
  public hardSkills$: Observable<JobseekerSkillViewModel[]>;
  public softSkills$: Observable<JobseekerSkillViewModel[]>;
  public hardSkillSuggestions$: Observable<SkillAutoCompleteResult>;
  public softSkillSuggestions$: Observable<SkillAutoCompleteResult>;

  public skillBaseType: any = SkillBaseTypeEnum;

  public employmentFormOptions$: Observable<EmploymentFormItem[]>;

  public locationCount$: Observable<number>;
  public experienceCount$: Observable<number>;

  public maxSelectedValue: number;

  private _logger: pino.Logger;

  get logger(): pino.Logger{
    return this._logger;
  }
 
  //TODO: remove
  // public categoryCount$: Observable<number>;

  constructor(private store: Store<AppState>, private router: Router, private location: Location, private route: ActivatedRoute, private announcementService: AnnouncementService, private ssr: SsrService, private loggingService: LogginService) {
    this._logger = this.loggingService.createLogger('ann-search-filter-component');
    this.maxSelectedValue = UI_LIMITS.MAX_VISIBLE_SELECTED_ITEMS
  }
  
  ngOnDestroy(): void {
    if(this.sub !== undefined && this.sub !== null){
      this.sub.unsubscribe();
    }
    if(this.routeParamsSub !== undefined && this.routeParamsSub !== null){
      this.routeParamsSub.unsubscribe();
    }
  }

  onLocationExpandToggle(){
    this.store.dispatch(toggleExpandLocationFilter());
  }

  onCategoryExpandToggle(){
    this.store.dispatch(toggleExpandCategoryFilter());
  }

  onSalaryExpandToggle(){
    this.store.dispatch(toggleExpandSalaryFilter());
  }

  onExperienceExpandToggle(){
    this.store.dispatch(toggleExpandExperienceFilter());
  }

  onAnnouncementTypeExpandToggle(){
    this.store.dispatch(toggleExpandAnnouncementTypeFilter());
  }

  onPublishDateExpandToggle(){
    this.store.dispatch(toggleExpandPublishDateFilter());
  }

  onMobileFilterExpandToggle(){
    this.store.dispatch(toggleExpandFilter());
  }

  onSearch(filter: AnnouncementFilter, salaryOptions: OptionItem<Range<number>>[], publishDateOptions: OptionItem<Range<number>>[]){
    this.store.dispatch(updateSubmittedFilter());
    
    let q = this.announcementService.convertFilterToQueryParams(filter, salaryOptions, publishDateOptions);
    q['pg'] = 1;
    
    this.router.navigate(['search-posting'], {
      queryParams: q
    });
  }

  onResetFilter(){
    this.store.dispatch(resetFilter());
  }

  onKeywordFilterChange(value: string){
    this.store.dispatch(updateKeywordFilter({ payload: { query: value } }));
  }

  // public convertQueryParamsToFilter(queryParams: ParamMap): AnnouncementFilter{
  //   let result = <AnnouncementFilter>{};

  //   if(queryParams.has(AnnouncementFilterQueryParams.AnnouncementType)){
  //     result.announcementTypeId = +queryParams.get(AnnouncementFilterQueryParams.AnnouncementType);
  //   }

  //   if(queryParams.has(AnnouncementFilterQueryParams.Categories)){
  //     result.categoryIds = JSON.parse(queryParams.get(AnnouncementFilterQueryParams.Categories));
  //   }

  //   if(queryParams.has(AnnouncementFilterQueryParams.Experience)){
  //     result.experienceRangeOptionIds = JSON.parse(queryParams.get(AnnouncementFilterQueryParams.Experience));
  //   }

  //   if(queryParams.has(AnnouncementFilterQueryParams.Locality)){
  //     result.localityIds = JSON.parse(queryParams.get(AnnouncementFilterQueryParams.Locality));
  //   }

  //   if(queryParams.has(AnnouncementFilterQueryParams.PublishDate)){
  //     result.publishDateRangeOptionId = +queryParams.get(AnnouncementFilterQueryParams.PublishDate);
  //   }

  //   if(queryParams.has(AnnouncementFilterQueryParams.Query)){
  //     result.query = queryParams.get(AnnouncementFilterQueryParams.Query);
  //   }

  //   if(queryParams.has(AnnouncementFilterQueryParams.Salary)){
  //     result.salaryRangeOptionId = +queryParams.get(AnnouncementFilterQueryParams.Salary);
  //   }

  //   return result;
  // }

  // public convertFilterToFullFilter(filter: AnnouncementFilter, state: AppState): AnnouncementFullFilter{
  //   let result = <AnnouncementFullFilter>{};
    
  //   let lookup = state.lookup;

  //   if(filter.query !== undefined){
  //     result.query = filter.query;
  //   }

  //   if(filter.announcementTypeId !== undefined){
  //     result.announcementTypeId = filter.announcementTypeId;
  //   }

  //   if(filter.localityIds !== undefined && filter.localityIds.length>0){
  //     result.localityIds = filter.localityIds;
  //   }

  //   if(filter.categoryIds !== undefined && filter.categoryIds.length>0){
  //     result.categoryIds = filter.categoryIds;
  //   }

  //   if(filter.salaryRangeOptionId !== undefined){
  //     let salary = lookup.salaryFilterOptions[filter.salaryRangeOptionId]
  //     result.salary = {
  //       from: salary.value.from,
  //       to: salary.value.to
  //     };
  //   }

  //   if(filter.publishDateRangeOptionId !== undefined){
  //     let publishDate = lookup.publishDateFilterOptions[filter.publishDateRangeOptionId];
  //     result.publishDate = {
  //       from: publishDate.value.from,
  //       to: publishDate.value.to
  //     };
  //   }

  //   if(filter.experienceRangeOptionIds !== undefined && filter.experienceRangeOptionIds.length > 0){
  //     let experienceOptions = filter.experienceRangeOptionIds.map(c => lookup.workExperienceFilterOptions[c]);
  //     result.experience = experienceOptions.map(c => ({ from: c.value.from, to: c.value.to}));
  //   }

  //   return result;
  // }

  // public convertFilterToQueryParams(filter: AnnouncementFilter, salaryOptions: OptionItem<Range<number>>[], publishDateOptions: OptionItem<Range<number>>[]): Params{
  //   let result = <Params> {};

  //   if(filter.query !== undefined){
  //     result[AnnouncementFilterQueryParams.Query] = filter.query;
  //   }

  //   if(filter.announcementTypeId !== undefined){
  //     result[AnnouncementFilterQueryParams.AnnouncementType] = filter.announcementTypeId;
  //   }

  //   if(filter.localityIds !== undefined && filter.localityIds.length>0){
  //     result[AnnouncementFilterQueryParams.Locality] = JSON.stringify(filter.localityIds);
  //   }

  //   if(filter.categoryIds !== undefined && filter.categoryIds.length>0){
  //     result[AnnouncementFilterQueryParams.Categories] = JSON.stringify(filter.categoryIds);
  //   }

  //   if(filter.salaryRangeOptionId !== undefined && salaryOptions[filter.salaryRangeOptionId].value !== undefined){
  //     result[AnnouncementFilterQueryParams.Salary] = filter.salaryRangeOptionId;
  //   }

  //   if(filter.publishDateRangeOptionId !== undefined && publishDateOptions[filter.publishDateRangeOptionId].value !== undefined){
  //     result[AnnouncementFilterQueryParams.PublishDate] = filter.publishDateRangeOptionId;
  //   }

  //   if(filter.experienceRangeOptionIds !== undefined && filter.experienceRangeOptionIds.length > 0){
  //     result[AnnouncementFilterQueryParams.Experience] = JSON.stringify(filter.experienceRangeOptionIds);
  //   }

  //   return result;
  // }

  
  ngOnInit(): void {


    //locations
    this.isLocationFilterExpanded$ = this.store.pipe(select(selectLocationExpanded));
    this.isLocationFilterActive$ = this.store.pipe(select(selectLocationFilterActive));

    this.workScheduleOptions$ = this.store.select(selectWorkScheduleOptions);

    //TODO: remove
    //categories
    // this.isCategoryFilterExpanded$ = this.store.pipe(select(selectCategoriesExpanded));
    // this.isCategoryFilterActive$ = this.store.pipe(select(selectCategoryFilterActive));

    //salary
    this.isSalaryFilterExpanded$ = this.store.pipe(select(selectSalaryExpanded));
    this.isSalaryFilterActive$ = this.store.pipe(select(selectSalaryFilterActive));

    // this.localityTree$ = this.store.pipe(select(selectLocalitiesTree))
    this.localityIds$ = this.store.pipe(select(selectLocalityIds))

    this.specializationCodes$ = this.store.pipe(select(selectSpecializationCodes))

    this.industryCodes$ = this.store.pipe(select(selectIndustryCodes));

    //work experience
    this.isExperienceFilterExpanded$ = this.store.pipe(select(selectExperienceExpanded));
    this.isExperienceFilterActive$ = this.store.pipe(select(selectExperienceFilterActive));

    this.experienceFilter$ = this.store.pipe(select(selectExperienceFilter));

    //announcement type
    this.isAnnouncementTypeFilterExpanded$ = this.store.pipe(select(selectAnnouncementTypeExpanded));
    this.isAnnouncementTypeFilterActive$ = this.store.pipe(select(selectAnnouncementTypeFilterActive));

    //publish date
    this.isPublishDateFilterExpanded$ = this.store.pipe(select(selectPublishDateExpanded));
    this.isPublishDateFilterActive$ = this.store.pipe(select(selectPublishDateFilterActive));

    //filter
    this.filter$ = this.store.pipe(select(selectFilter));
    this.salaryOptions$ = this.store.pipe(select(selectSalaryOptions({ emptyItemName: 'All'})));
    this.publishDateOptions$ = this.store.pipe(select(selectPublishDateOptions));
    this.seniorityLevelOptions$ = this.store.pipe(select(selectSeniorityLevelOptions));
    this.transportTypeOptions$ = this.store.pipe(select(selectTransportTypeOptions));
    this.drivingLicenceOptions$ = this.store.pipe(select(selectDrivingLicenceOptions));
    this.educationLevelOptions$ = this.store.pipe(select(selectEducationLevelOptions));
    this.languageOptions$ = this.store.pipe(select(selectWorldLanguages));
    this.languageIds$ = this.store.pipe(select(selectLanguageIds));

    //skills
    this.hardSkills$ = this.store.pipe(select(selectHardSkills));
    this.softSkills$ = this.store.pipe(select(selectSoftSkills));
    this.hardSkillSuggestions$ = this.store.pipe(select(selectSkillSuggestions(SkillBaseTypeEnum.Hard)));
    this.softSkillSuggestions$ = this.store.pipe(select(selectSkillSuggestions(SkillBaseTypeEnum.Soft)));

    this.employmentFormOptions$ = this.store.pipe(select(selectEmploymentFormOptions));
    this.publishDefaultDateOption$ = this.store.pipe(select(selectDefaultPublishDateOption));

    this.isFilterExpanded$ = this.store.pipe(select(selectFilterExpanded));

    this.locationCount$ = this.store.pipe(select(selectLocationCount));
    this.experienceCount$ = this.store.pipe(select(selectExperienceCount));
    
    //remove
    // this.categoryCount$ = this.store.pipe(select(selectCategoryCount));

    this.categoryTree$ = this.store.pipe(select(selectCategoriesTree));
    this.categoryIds$ = this.store.pipe(select(selectCategoryIds));

    this.store.dispatch(SearchPageActions.loadFilterStats());

    let queryParamMap$ = this.route.queryParamMap;
    let lookup$ = this.store.pipe(select(selectSearchResultsStateInfo), filter(c => c.pageSize !== undefined && c.isLookupLoaded));

    this.sub = this.router.events.pipe(
      filter(event => event instanceof NavigationSkipped), 
      map(_ => true)
    )
    .subscribe(this.forceRefresh$);

    this.routeParamsSub = combineLatest([queryParamMap$, lookup$, this.forceRefresh$])
      .subscribe(([p, l]) => {
        let filter = this.announcementService.convertQueryParamsToFilter(p);
        let fullFilter = this.announcementService.convertFilterToFullFilter(filter, l.lookup, l.pageSize);

        if(this.ssr.isPlatformServer() && (p.has('cc') || p.has('c'))){
          //let queryParams = this.announcementService.convertFilterToQueryParams(filter, l.lookup.salaryFilterOptions, l.lookup.publishDateFilterOptions);
          //let currentPath = this.route.snapshot.url.map(segment => segment.path).join('/');

          const urlTree = this.router.createUrlTree([], { queryParams: { cc: null, c: null}, queryParamsHandling: 'merge'});
          const newUrl = this.router.serializeUrl(urlTree);

          this.logger.warn(`Old url detected: ${this.router.url}, redirecting to new url: ${newUrl}`);

          const absoluteUrl = this.location.prepareExternalUrl(newUrl);

          this.ssr.setStatusMovedPermanently(absoluteUrl);

          return;
        }

        this.store.dispatch(updateFilter({ payload: filter }));

        //the url only carries skill codes, so the titles of the chosen skills are loaded separately
        let selectedSkillCodes = [...(filter.hardSkillCodeList ?? []), ...(filter.softSkillCodeList ?? [])];

        if(selectedSkillCodes.length > 0){
          this.store.dispatch(loadSelectedSkills({ payload: { codes: selectedSkillCodes } }));
        }

        this.store.dispatch(announcementSearch({payload: fullFilter}));//TODO bad design, read in effect directly from store?
    });
  }

  onToggleCategory(event: number[]){
    this.store.dispatch(updateCategoryilter( { payload: { categoryIds: event } }));
  }

  onToggleLocality(event:number[]){
    this.store.dispatch(updateLocalityFilter({ payload: {localityIds: event}}));
  }

  onToggleSpecialization(event:string[]){
    this.store.dispatch(updateSpecializationFilter({ payload: {specializationCodes: event}}));
  }

  onToggleIndustry(event:string[]){
    this.store.dispatch(updateIndustryFilter({ payload: {industryCodes: event}}));
  }

  onChangePublishDateRangeOption(event){
    this.store.dispatch(updatePublishDateFilter( { payload: { publishDateRangeOptionId: event } }));
  }

  onClearPublishDateRange(){
    this.store.dispatch(updatePublishDateFilter( { payload: { publishDateRangeOptionId: 0 } }));
  }

  onChangeSeniorityLevelOption(event){
    this.store.dispatch(updateSeniorityLevelFilter( { payload: { seniorityLevelCodes: event.value } }));
  }

  onChangeEmploymentFormTypeOption(event){
    this.store.dispatch(updateEmploymentFormTypeFilter( { payload: { employmentFormIds: event.value } }));
  }

  onChangeTransportTypeOption(event){
    this.store.dispatch(updateTransportTypeFilter( { payload: { transportTypeIds: event.value } }));
  }

  onChangeWorkScheduleOption(event){
    this.store.dispatch(updateWorkScheduleFilter( { payload: { workScheduleCodes: event.value } }));
  }

  onClearSeniorityLevel(){
    this.store.dispatch(updateSeniorityLevelFilter( { payload: { seniorityLevelCodes: undefined } }));
  }

  onClearEmploymentForms(){
    this.store.dispatch(updateEmploymentFormTypeFilter( { payload: { employmentFormIds: undefined } }));
  }

  onClearTransportTypes(){
    this.store.dispatch(updateTransportTypeFilter( { payload: { transportTypeIds: undefined } }));
  }

  onChangeDrivingLicenceOption(event){
    this.store.dispatch(updateDrivingLicenceFilter( { payload: { drivingLicenceIds: event.value } }));
  }

  onClearDrivingLicences(){
    this.store.dispatch(updateDrivingLicenceFilter( { payload: { drivingLicenceIds: undefined } }));
  }

  onChangeLanguageOption(event){
    this.store.dispatch(updateLanguageFilter( { payload: { worldLanguageIds: event.value } }));
  }

  onClearLanguages(){
    this.store.dispatch(updateLanguageFilter( { payload: { worldLanguageIds: undefined } }));
  }

  onChangeEducationLevelOption(event){
    this.store.dispatch(updateEducationLevelFilter( { payload: { educationLevelCodes: event.value } }));
  }

  onClearEducationLevels(){
    this.store.dispatch(updateEducationLevelFilter( { payload: { educationLevelCodes: undefined } }));
  }

  onClearWorkSchedule(){
    this.store.dispatch(updateWorkScheduleFilter( { payload: { workScheduleCodes: undefined } }));
  }

  onToggleExperienceRangeOption(event){
    this.store.dispatch(updateExperienceFilter( { payload: { experienceFilter: event } }));
  }

  onChangeSalaryRangeOption(event){
    this.store.dispatch(updateSalaryFilter( { payload: { salaryRangeOptionId: event } }));
  }

  onOnlySelectedSalary(event){
    this.store.dispatch(updateOnlySelectedSalaryFilter ( { payload:  event }));
  }
  onEmploymentFormChange(event){
    this.store.dispatch(updateEmploymentFormFilter({ payload: { employmentFormTypeIds: event }}))
  }

  //skills
  onSkillQueryChange(query: string, skillBaseType: SkillBaseTypeEnum, chosenSkills: JobseekerSkillViewModel[] | null){
    this.store.dispatch(loadSkillSuggestions({
      payload: {
        query: query ?? '',
        skillBaseType: skillBaseType,
        selectedCanonicalSkillIds: (chosenSkills ?? []).map(s => s.canonicalSkillId).filter(id => id != null),
        selectedCustomSkills: []
      }
    }));
  }

  onSkillsChange(skills: JobseekerSkillViewModel[], skillBaseType: SkillBaseTypeEnum){
    this.store.dispatch(updateSkillsFilter({ payload: { skillBaseType: skillBaseType, skills: skills } }));
  }
}
